/**
 * V2 app footer — the end-of-page door to the Tell Us box (ui/tell-us.js).
 *
 * IN FLOW, not fixed: the page is the point, and a permanent bar would be
 * one more thing standing in front of it (the visitor ribbon already owns
 * the bottom edge for signed-out arrivals). You reach the footer by
 * finishing the page, which is exactly when someone has something to say.
 *
 * That trade has one known cost, and it is why the Help dialog carries the
 * same button (ui/nav.js): Discover loads another page of cards whenever
 * you come within 300px of the bottom (discover.js), so on the feed the end
 * of the document keeps moving away and the footer is not reachable until
 * the feed runs out. Every page that ENDS — a yoink, a place, a profile, a
 * list, a category — gets the footer the way you'd expect.
 *
 * It lives in the app chrome, OUTSIDE #v2-app, because views repaint their
 * whole root with innerHTML — anything mounted inside dies on the next
 * render.
 */
import { openTellUs } from './tell-us.js';

export function mount(el, ctx) {
  const { store, router } = ctx;

  const year = new Date().getFullYear();
  el.innerHTML = `
    <footer class="v2-footer">
      <p class="v2-footer-line">
        Yoink is in beta — we’re building this thing in public. Got ideas, gripes, a place we got wrong?
      </p>
      <div class="v2-footer-actions">
        <button type="button" class="v2-footer-tell" data-tell-open>Tell Us</button>
        <a class="v2-footer-link" href="https://yoinkadventures.com/how-it-works/"
          target="_blank" rel="noopener">How it works</a>
      </div>
      <p class="v2-footer-fine">© ${year} Yoink Adventures · Discover. Log. Share.</p>
    </footer>`;

  function onClick(event) {
    if (event.target.closest('[data-tell-open]')) openTellUs({ store, router });
  }

  el.addEventListener('click', onClick);
  return () => el.removeEventListener('click', onClick);
}
